// @ts-nocheck

import { createSelector } from 'reselect';

import { selectRuntimeLicence } from '../../../../selectors/runtime/runtimePrimary.selector';
import { selectUserConnected, selectUserDidReceivedUserData } from '../../../../selectors/user/userPrimary.selector';
import { MPBannerBackgroundPathByLicences } from '../../constants/assets';
import { MPBannerStatuses } from '../../types/banner';
import { MPUserStatuses } from '../../types/user';
import { selectHasMPUserAnyFamilyCompletedNotification, selectMPUserStatus } from '../user';

const MPBannerSelectors = {};

MPBannerSelectors.selectBannerStatus = createSelector(
  [
    selectUserConnected,
    selectMPUserStatus,
    selectUserDidReceivedUserData,
    selectHasMPUserAnyFamilyCompletedNotification,
  ],
  (isUserConnected, userStatus, didReceivedUserData, hasMPUserAnyFamilyCompletedNotification) => {
    if (isUserConnected && didReceivedUserData) {
      if (userStatus === MPUserStatuses.OFF) {
        return MPBannerStatuses.NOT_OPT_IN_YET;
      }

      if (hasMPUserAnyFamilyCompletedNotification) {
        return MPBannerStatuses.FREEBETS_AVAILABLE;
      }

      return MPBannerStatuses.PLAYING;
    }

    return MPBannerStatuses.NOT_CONNECTED;
  },
);

MPBannerSelectors.selectBackgroundPath = createSelector(
  [selectRuntimeLicence],
  (licence) => MPBannerBackgroundPathByLicences[licence],
);

export default MPBannerSelectors;
